import React from 'react'
import MyProfile from './myprofile';

export default function MediumEdit() {
  return (
    <MyProfile />
  )
}
